import { ReactNode } from 'react'

import { Text, View } from '@react-pdf/renderer'

export const MainTitle: React.FC<{ children: ReactNode }> = ({ children }) => (
  <View>
    <Text style={{ fontSize: 18, fontWeight: 'black' }}>{children}</Text>
  </View>
)
export const SectionTitle: React.FC<{ children: ReactNode }> = ({ children }) => (
  <View style={{ marginBottom: 4 }}>
    <Text style={{ fontSize: 14, fontWeight: 'black' }}>{children}</Text>
  </View>
)

export const Section: React.FC<{ children: ReactNode }> = ({ children }) => (
  <View style={{ marginVertical: 10 }}>{children}</View>
)
